import React, { useEffect } from "react";

function GoodBookingSuccess(props) {
  const { navigation, t, values, resetFormToInitial } = props;
  const appointmentReference =
    (values && values.goodConductAppointmentReference) || "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackToEmbassy = () => {
    const locale = values && values.locale ? values.locale : "en";
    if (typeof resetFormToInitial === "function") {
      resetFormToInitial({ locale });
    }
    navigation.go("select-embassy");
  };

  return (
    <div className="good-booking-success mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-sm-12 col-lg-10">
          <div className="gc-success-card text-center p-4 p-md-5">
            <img
              src="./images/checkmark-circle.svg"
              alt=""
              className="gc-success-icon mb-4"
            />
            <h2 className="mb-3">{t("GC_SUCCESS_TITLE")}</h2>
            <p className="p-text mb-4 px-md-4">{t("GC_SUCCESS_BODY")}</p>
            {appointmentReference ? (
              <p
                className="p-text mb-4 px-md-4 fw-semibold gc-success-reference"
                dir="ltr"
              >
                {t("GC_SUCCESS_REFERENCE", {
                  reference: appointmentReference,
                })}
              </p>
            ) : null}
            <button
              type="button"
              className="btn btn-primary btn-lg emx-button"
              onClick={handleBackToEmbassy}
            >
              {t("GC_SUCCESS_DONE")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoodBookingSuccess;
